export default {
    API_ENDPOINT: 'https://glacial-dawn-18195.herokuapp.com/api'
  }
  